import { OrdersTable } from "./orders-table";

export function EnhancedOrdersTable() {
  return <OrdersTable />;
}
